import { HttpQueryPrimitive } from '@/app/core/services/http';

type BooleanFormat = 'trueFalse' | 'zeroOne';
export type DateFormat = 'iso' | ((date: Date) => string);

export interface FormatFilterValueOptions {
  booleanFormat?: BooleanFormat;
  dateFormat?: DateFormat;
}

export function formatFilterValue(value: HttpQueryPrimitive, options: FormatFilterValueOptions = {}): string {
  const { booleanFormat = 'zeroOne', dateFormat = 'iso' } = options;

  if (value instanceof Date) {
    if (typeof dateFormat === 'function') {
      return dateFormat(value);
    }
    return value.toISOString();
  }

  if (typeof value === 'boolean') {
    return booleanFormat === 'zeroOne' ? (value ? '1' : '0') : value.toString();
  }

  return value.toString();
}
